<div class="detalle-summary">
  <!-- Valor Total Deducido -->
  <div class="summary-item">
    <span class="summary-label">Valor Total Deducido:</span>
    <span
      class="summary-value"
      [class.text-muted]="valorTotalDeducido() === 0"
      [class.text-success]="valorTotalDeducido() > 0"
    >
      {{ valorTotalDeducido() | currency: 'COP' : 'symbol' : '1.2-2' }}
    </span>
  </div>

  <!-- Valor Por Deducir -->
  <div class="summary-item">
    <span class="summary-label">Valor Por Deducir:</span>
    <span
      class="summary-value"
      [class.text-success]="saldoCero()"
      [class.text-warning]="!saldoCero() && valorPorDeducir() > 0"
    >
      {{ valorPorDeducir() | currency: 'COP' : 'symbol' : '1.2-2' }}
      @if (saldoCero()) {
        <span class="status-badge success">✓ Saldado</span>
      } @else {
        <span class="status-badge warning">Pendiente</span>
      }
    </span>
  </div>

  <!-- Total Cuotas -->
  <div class="summary-item">
    <span class="summary-label">Total Cuotas:</span>
    <span class="summary-value">
      {{ totalCuotas() }}
    </span>
  </div>

  <!-- Cuotas Pagadas -->
  <div class="summary-item">
    <span class="summary-label">Cuotas Pagadas:</span>
    <span
      class="summary-value"
      [class.text-success]="cuotasPagadas() > 0"
      [class.text-muted]="cuotasPagadas() === 0"
    >
      {{ cuotasPagadas() }}
      @if (tieneCuotas()) {
        <span class="percentage-badge">
          {{ (cuotasPagadas() / totalCuotas()) * 100 | number: '1.0-0' }}%
        </span>
      }
    </span>
  </div>

  <!-- Cuotas Pendientes -->
  <div class="summary-item">
    <span class="summary-label">Cuotas Pendientes:</span>
    <span
      class="summary-value"
      [class.text-warning]="cuotasPendientes() > 0"
      [class.text-success]="cuotasPendientes() === 0"
    >
      {{ cuotasPendientes() }}
      @if (tieneCuotas()) {
        <span class="percentage-badge">
          {{ (cuotasPendientes() / totalCuotas()) * 100 | number: '1.0-0' }}%
        </span>
      }
    </span>
  </div>
</div>
